import { type FC, useCallback, useState } from 'react';
import styles from './Header.module.scss';
import { Navigation } from './components/Navigation';
import { NotificationBell } from './components/NotificationBell';
import { NewSitePopup } from '../NewSitePopup';
import { SitesDropdown } from 'src/redesign/features/Header/components/Dropdown';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { SwitchButton } from 'src/redesign/components/SwitchButton';
import { accountActions } from 'src/redesign/features/Account/store/reducer';
import { useAppDispatch } from 'src/hooks';
import { useWhiteLabel } from 'src/redesign/features/WhiteLabel';

export const Header: FC = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [isAddSitePopupVisible, setIsAddSitePopupVisible] = useState(false);
  const { logoUrl, siteName } = useWhiteLabel();
  const handleOnAddSiteClick = () => {
    setIsAddSitePopupVisible(true);
  };
  const handleAddSitePopupClose = () => {
    setIsAddSitePopupVisible(false);
  };

  const handleSwitchRole = useCallback(
    (role: string) => {
      if (role === 'My Tickets') {
        dispatch(accountActions.switchRole('attendee'));
        history.replace('/attendee-dashboard');
        return;
      }
      dispatch(accountActions.switchRole('host'));
      history.replace('/events');
    },
    [dispatch, history],
  );

  // Determine current switch value based on route
  const currentSwitchValue = location.pathname.includes('attendee-dashboard')
    ? 'My Tickets'
    : 'Host';

  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <div className={styles.leftContent}>
          <Link to="/">
            <img
              className={styles.logo}
              src={logoUrl || 'https://cdn.ticketspot.io/logo.png'}
              alt={siteName || 'logo'}
            />
          </Link>
          <SitesDropdown onAddSiteClick={handleOnAddSiteClick} />
        </div>

        <div className={styles.switchContainer} style={{ margin: '0 12px' }}>
          <SwitchButton
            onChange={handleSwitchRole}
            items={['Host', 'My Tickets']}
            value={currentSwitchValue}
          />
        </div>

        <div className={styles.rightContent}>
          <div className={styles.hideOnMobile}>
            <NotificationBell />
          </div>
          <Navigation />
        </div>
      </div>
      <NewSitePopup isOpen={isAddSitePopupVisible} onClose={handleAddSitePopupClose} />
    </header>
  );
};
